<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog" v-if="showModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('delete') }} {{ $t(target.name) }}</h5>
                        <button type="button" class="btn-close" @click="closeModal"></button>
                    </div>
                    <div class="modal-body">
                        <SearchTool :placeholder="$t('search') + ' ' + $t(target.name) + '...'" :data="data"
                            :label="target.label" :track-by="target.track_by" @select="handleSelect" />
                        <div class="row mt-2">{{ $t('delete_help') }}</div>
                        <div v-if="message" :class="alertClass">{{ message }}</div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="deleteSelected">{{ $t('apply') }}</button>
                        <button type="button" class="btn btn-secondary" @click="closeModal">{{ $t('cancel') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const { getCookie } = require('@/helpers');
import SearchTool from './SearchTool.vue';
import axios from 'axios';

export default {
    components: {
        SearchTool
    },
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        data: {
            type: Array,
            default: () => []
        },
        target: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            selected: [],
            message: '',
            alertClass: ''
        };
    },
    emits: ['close-modal', 'data-updated'],
    methods: {
        handleSelect(selected) {
            this.selected = selected;
        },
        async deleteSelected() {
            const confirmed = confirm(this.$t('confirm_delete'));
            if (confirmed) {
                try {
                    const url = `${this.$url}/` + this.target.name;
                    await axios.delete(url, {
                        data: this.selected,
                        headers: {
                            Authorization: 'Bearer ' + getCookie('token'),
                            ContentType: 'application/json'
                        }
                    });
                    // Handle successful response
                    this.setMessage(this.$t('successfully_deleted'), true);
                    this.$emit('data-updated');
                    // Close modal after 3 seconds
                    setTimeout(() => {
                        this.closeModal();
                        this.message = ''; // Clear confirmation message
                    }, 3000);
                } catch (error) {
                    console.error('Error deleting:', error);
                    if (error.response && error.response.data) {
                        this.setMessage(this.$t('error') + ': ' + error.response.data, false);
                    } else {
                        this.setMessage(this.$t('error') + ': ' + error.message, false);
                    }
                }
            } else {
                this.setMessage(this.$t('delete_cancelled'), false);
            }

        },
        setMessage(message, isSuccess) {
            this.message = message;
            this.alertClass = isSuccess ? 'alert alert-success' : 'alert alert-warning';
        },
        closeModal() {
            this.$emit('close-modal');
        }
    }
};
</script>

<style scoped>
.modal {
    display: block;
    /* Ensure modal is displayed */
}
</style>